import { ChangeDetectionStrategy, Component, input } from "@angular/core";

/**
 * Znak marki Księgowskaz — logo poziome (sygnet + nazwa) z dopiskiem modułu „Kadry".
 *
 * Geometria i kolory pochodzą 1:1 z paczki marki
 * (`svg/ksiegowskaz-logo-poziom-kolor.svg`, siatka 22 × 22 modułów).
 * Wersja podstawowa (kolor) na jasnym tle, negatyw na ciemnym — księga znaku
 * zabrania używania wersji podstawowej na Graficie leśnym.
 * Nie dokrawamy pliku: sygnet ma wbudowany margines 2x u góry i u dołu.
 */
@Component({
  selector: "app-brand-logo",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./brand-logo.html",
  host: {
    class: "app-brand",
    role: "img",
    "aria-label": "Księgowskaz Kadry",
    "[class.app-brand--lg]": "size() === 'lg'",
  },
  styleUrl: "./brand-logo.scss",
})
export class BrandLogo {
  /** `lg` — ekran logowania; `md` — pasek górny. */
  readonly size = input<"md" | "lg">("md");
}
